import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Outlet } from 'react-router-dom';
import { Button } from 'primereact/button';
import { Image } from 'primereact/image';
import { Sidebar } from 'primereact/sidebar';

import WebsiteTopBanner from 'components/WebsiteTopBanner';

// import functions from 'lib/functions';
// import fetchApi from 'lib/fetchApi';
// import { app } from 'lib/configs';

const LayoutDashboard = (props) => {
  const navigate = useNavigate();
  const [sidebarVisible, setSidebarVisible] = useState(false);


  return <Outlet />;
  
  // return (
  //   <>
  //     <div className="flex flex-column">
  //       <WebsiteTopBanner />
  //       <Outlet />
  //     </div>
  //   </>
  // )
};

export default LayoutDashboard;
